{
  "familyId": "REK-CONTEXT-KEER-DEEL",
  "questions": [
    {
      "id": "REK-CONTEXT-KEER-DEEL-001",
      "familyId": "REK-CONTEXT-KEER-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_vermenigvuldigen_delen",
      "questionType": "multiple_choice",
      "question": "Een bakker bakt elke dag 144 broodjes. Ze verpakt ze in zakken van 12. Hoeveel zakken heeft ze nodig?",
      "options": ["12 zakken", "14 zakken", "11 zakken", "13 zakken"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "barModel",
          "showWhen": "wrong",
          "data": {
            "total": 144,
            "totalLabel": "144 broodjes",
            "segments": 12,
            "showSegmentValues": false,
            "label": "Verdeel 144 broodjes over 12 zakken — elk vakje = 1 zak"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verdelen = delen",
            "content": "Je verdeelt 144 broodjes in groepjes van 12. Dat is delen: 144 ÷ 12 = 12 zakken. Tip: als je iets 'gelijk verdeelt' of 'in groepjes' stopt, is dat altijd delen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_keer_deel_verdelen",
      "variantIndex": 1,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "144 broodjes in zakken van 12 = 144 ÷ 12 = 12 zakken. Het signaalwoord 'verpakt in zakken van' wijst op delen. Je verdeelt het totaal in gelijke groepjes. Tegenproef: 12 × 12 = 144 ✓",
        "solutionSteps": [
          "Herken de bewerking: verdelen in groepjes = delen",
          "144 ÷ 12 = 12",
          "De bakker heeft 12 zakken nodig"
        ],
        "distractorExplanations": {
          "0": "Goed! 144 ÷ 12 = 12 zakken. Je hebt het totaal aantal broodjes correct verdeeld over de zakken.",
          "1": "Je dacht waarschijnlijk 144 ÷ 12 ≈ 14. Maar 14 × 12 = 168 ≠ 144. Controleer: 12 × 12 = 144. ✓",
          "2": "Je dacht waarschijnlijk 144 ÷ 12 ≈ 11. Maar 11 × 12 = 132 ≠ 144. Controleer: 12 × 12 = 144. ✓",
          "3": "Je dacht waarschijnlijk 144 ÷ 12 ≈ 13. Maar 13 × 12 = 156 ≠ 144. Controleer: 12 × 12 = 144. ✓"
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.calculation-error", "label": "Deelfout: 144÷12≈14", "optionIndex": 1 },
          { "id": "rek.calculation-error", "label": "Deelfout: 144÷12≈11", "optionIndex": 2 },
          { "id": "rek.calculation-error", "label": "Deelfout: 144÷12≈13", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-CONTEXT-KEER-DEEL-002",
      "familyId": "REK-CONTEXT-KEER-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_vermenigvuldigen_delen",
      "questionType": "fill_in",
      "question": "Een tuinman plant 15 rijen met elk 24 bloembollen. Hoeveel bloembollen plant hij in totaal?",
      "options": [],
      "correctAnswer": "360",
      "data": {
        "acceptedAnswers": ["360", "360 bloembollen"]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "barModel",
          "showWhen": "wrong",
          "data": {
            "total": 360,
            "totalLabel": "360 bollen",
            "segments": 15,
            "showSegmentValues": false,
            "label": "15 rijen × 24 bollen — elk vakje = 1 rij"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Rijen × per rij = totaal",
            "content": "15 rijen met elk 24 bollen = 15 × 24. Handig: 15 × 24 = 15 × 20 + 15 × 4 = 300 + 60 = 360. Signaalwoord: 'rijen met elk' wijst op vermenigvuldigen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_keer_deel_rijen",
      "variantIndex": 2,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "15 rijen × 24 bollen = 360 bollen. Signaalwoord: 'rijen met elk' wijst op vermenigvuldigen. Handig: 15 × 24 = 15 × 20 + 15 × 4 = 300 + 60 = 360. Tegenproef: 360 ÷ 15 = 24 ✓",
        "solutionSteps": [
          "Herken: rijen × per rij = vermenigvuldigen",
          "15 × 24 = 15 × 20 + 15 × 4",
          "300 + 60 = 360 bloembollen"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.calculation-error", "label": "Vermenigvuldigfout: 15×24≈350" },
          { "id": "rek.calculation-error", "label": "Vermenigvuldigfout: 15×24≈340" },
          { "id": "rek.rounding-wrong-direction", "label": "Rondt 24 af naar 25: 15×25=375" }
        ]
      }
    },
    {
      "id": "REK-CONTEXT-KEER-DEEL-003",
      "familyId": "REK-CONTEXT-KEER-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_vermenigvuldigen_delen",
      "questionType": "multiple_choice",
      "question": "Een school bestelt 756 pennen. De pennen worden geleverd in dozen van 18. Hoeveel dozen moet de school bestellen?",
      "options": ["40 dozen", "42 dozen", "44 dozen", "38 dozen"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "splitDiagram",
          "showWhen": "wrong",
          "data": {
            "original": 756,
            "parts": [
              { "value": 720, "label": "720 ÷ 18 = 40" },
              { "value": 36, "label": "36 ÷ 18 = 2" }
            ],
            "operation": "divide",
            "operand": 18,
            "result": 42,
            "label": "Splits 756 in 720 + 36, deel allebei door 18"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoeveel dozen? = delen",
            "content": "'Hoeveel dozen van 18 passen in 756?' = 756 ÷ 18. Handig: 756 ÷ 18 = 756 ÷ 2 ÷ 9 = 378 ÷ 9 = 42. Of: 18 × 40 = 720, rest 36. 36 ÷ 18 = 2. Totaal: 42 dozen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_keer_deel_dozen",
      "variantIndex": 3,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.82,
      "feedback": {
        "explanationText": "756 ÷ 18 = 42 dozen. Signaalwoord: 'dozen van 18' wijst op delen. Handig: 756 ÷ 2 = 378, dan 378 ÷ 9 = 42. De school moet 42 dozen bestellen. Tegenproef: 42 × 18 = 756 ✓",
        "solutionSteps": [
          "Herken: totaal ÷ per doos = aantal dozen",
          "756 ÷ 18 = 756 ÷ 2 ÷ 9",
          "378 ÷ 9 = 42 dozen"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk 756 / 18 = 40. Maar 40 x 18 = 720, niet 756. Er zijn nog 36 pennen over: 36 / 18 = 2 dozen extra. Totaal: 42.",
          "1": "Goed! 756 ÷ 18 = 42 dozen. Je hebt het totaal aantal pennen correct verdeeld.",
          "2": "Je dacht waarschijnlijk 756 / 18 = 44. Maar 44 x 18 = 792, niet 756. Controleer: 42 x 18 = 756.",
          "3": "Je dacht waarschijnlijk 756 / 20 = 37,8 dus 38. Maar de deler is 18, niet 20. 756 / 18 = 42."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.division-remainder-ignored", "label": "Vergeet rest bij deling: 756÷18≈40", "optionIndex": 0 },
          { "id": "rek.calculation-error", "label": "Deelfout: 756÷18≈44", "optionIndex": 2 },
          { "id": "rek.context-wrong-data", "label": "Deelt door 20 i.p.v. 18", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-CONTEXT-KEER-DEEL-004",
      "familyId": "REK-CONTEXT-KEER-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_vermenigvuldigen_delen",
      "questionType": "fill_in",
      "question": "Een fietsenmaker vervangt 4 banden per fiets. Hij heeft 348 banden op voorraad. Hoeveel fietsen kan hij volledig van nieuwe banden voorzien?",
      "options": [],
      "correctAnswer": "87",
      "data": {
        "acceptedAnswers": ["87", "87 fietsen"]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Per fiets = delen",
            "content": "Elke fiets heeft 4 banden nodig. Hoeveel fietsen van 348 banden? 348 ÷ 4 = 87. Let op: een fiets heeft 2 wielen, maar elk wiel heeft 2 banden (binnen- en buitenband). Dus 4 banden per fiets.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_keer_deel_per_stuk",
      "variantIndex": 4,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "348 banden ÷ 4 banden per fiets = 87 fietsen. Signaalwoord: 'per fiets' wijst op delen. 348 ÷ 4 = 87. De fietsenmaker kan 87 fietsen volledig van nieuwe banden voorzien. Tegenproef: 87 × 4 = 348 ✓",
        "solutionSteps": [
          "Herken: totaal ÷ per fiets = aantal fietsen",
          "348 ÷ 4 = 87",
          "87 fietsen volledig voorzien"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.calculation-error", "label": "Deelfout: 348÷4≈86" },
          { "id": "rek.calculation-error", "label": "Deelfout: 348÷4≈88" },
          { "id": "rek.calculation-error", "label": "Deelfout: 348÷4≈84" }
        ]
      }
    },
    {
      "id": "REK-CONTEXT-KEER-DEEL-005",
      "familyId": "REK-CONTEXT-KEER-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_vermenigvuldigen_delen",
      "questionType": "multiple_choice",
      "question": "Een drukkerij drukt 28 pagina's per minuut. Een boek heeft 336 pagina's. Hoeveel minuten duurt het om één boek te drukken?",
      "options": ["14 minuten", "10 minuten", "12 minuten", "11 minuten"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Totaal ÷ per minuut = tijd",
            "content": "336 pagina's ÷ 28 pagina's per minuut = 12 minuten. Handig: 336 ÷ 28 = 336 ÷ 4 ÷ 7 = 84 ÷ 7 = 12. Signaalwoord: 'per minuut' wijst op delen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_keer_deel_snelheid",
      "variantIndex": 5,
      "citoDifficulty": 0.54,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "336 ÷ 28 = 12 minuten. Signaalwoord: 'per minuut' wijst op delen. Handig: splits 28 in factoren: 28 = 4 × 7. Eerst 336 ÷ 4 = 84, dan 84 ÷ 7 = 12. Tegenproef: 12 × 28 = 336 ✓",
        "solutionSteps": [
          "Herken: totaal ÷ per minuut = aantal minuten",
          "336 ÷ 28 = 336 ÷ 4 ÷ 7",
          "84 ÷ 7 = 12 minuten"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk 336 / 24 = 14. Maar de snelheid is 28 pagina's per minuut, niet 24. 336 / 28 = 12.",
          "1": "Je dacht waarschijnlijk 336 / 28 = 10. Maar 10 x 28 = 280, niet 336. Controleer: 12 x 28 = 336.",
          "2": "Goed! 336 ÷ 28 = 12 minuten. Je hebt het totaal aantal pagina's correct gedeeld door de snelheid.",
          "3": "Je dacht waarschijnlijk 336 / 28 = 11. Maar 11 x 28 = 308, niet 336. Controleer: 12 x 28 = 336."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.context-wrong-data", "label": "Deelt door 24 i.p.v. 28", "optionIndex": 0 },
          { "id": "rek.calculation-error", "label": "Deelfout: 336÷28≈10", "optionIndex": 1 },
          { "id": "rek.calculation-error", "label": "Deelfout: 336÷28≈11", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-CONTEXT-KEER-DEEL-006",
      "familyId": "REK-CONTEXT-KEER-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_vermenigvuldigen_delen",
      "questionType": "step_solver",
      "question": "Een boer heeft 480 appels. Hij verpakt ze in kratten van 24. Hoeveel kratten heeft hij nodig? Los stap voor stap op.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "steps": [
          {
            "prompt": "Welke bewerking gebruik je? Verdelen in groepjes = ...",
            "correctAnswer": "delen",
            "acceptedAnswers": ["delen", "÷", "deelsom"],
            "hint": "Je verdeelt 480 appels in groepjes van 24. Dat is ..."
          },
          {
            "prompt": "Bereken: 480 ÷ 24 = ? (Tip: 480 ÷ 4 = 120, dan 120 ÷ 6 = ?)",
            "correctAnswer": "20",
            "acceptedAnswers": ["20"],
            "hint": "480 ÷ 24. Splits 24 in 4 × 6. Eerst 480 ÷ 4 = 120. Dan 120 ÷ 6 = ?"
          },
          {
            "prompt": "Controleer: 20 × 24 = ?",
            "correctAnswer": "480",
            "acceptedAnswers": ["480"],
            "hint": "20 × 24 = 20 × 20 + 20 × 4 = ?"
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verdelen = delen",
            "content": "480 appels in kratten van 24 = 480 ÷ 24. Handig: splits 24 in factoren: 24 = 4 × 6. Eerst 480 ÷ 4 = 120, dan 120 ÷ 6 = 20.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_keer_deel_step_solver",
      "variantIndex": 6,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "480 appels ÷ 24 per krat = 20 kratten. Handig rekenen: 480 ÷ 4 = 120, dan 120 ÷ 6 = 20. Controleer: 20 × 24 = 480 ✓.",
        "solutionSteps": [
          "Herken: verdelen in groepjes = delen",
          "480 ÷ 24 = 480 ÷ 4 ÷ 6 = 120 ÷ 6 = 20",
          "Controleer: 20 × 24 = 480 ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "REK-CONTEXT-KEER-DEEL-007",
      "familyId": "REK-CONTEXT-KEER-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_vermenigvuldigen_delen",
      "questionType": "multiple_choice",
      "question": "Op het schoolreisje gaan 192 leerlingen mee. Ze worden verdeeld over groepjes van 8 om de speurtocht te doen. Hoeveel groepjes zijn er?",
      "options": ["22 groepjes", "24 groepjes", "26 groepjes", "21 groepjes"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verdelen in groepjes = delen",
            "content": "192 leerlingen in groepjes van 8 = 192 ÷ 8. Handig: splits 192 in 160 + 32. 160 ÷ 8 = 20, 32 ÷ 8 = 4, samen 24 groepjes.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_keer_deel_schoolreisje",
      "variantIndex": 7,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "192 ÷ 8 = 24 groepjes. Signaalwoord: 'verdeeld over groepjes van' wijst op delen. Handig: 192 = 160 + 32. 160 ÷ 8 = 20, 32 ÷ 8 = 4, samen 24. Tegenproef: 24 × 8 = 192 ✓",
        "solutionSteps": [
          "Herken: verdelen in groepjes = delen",
          "192 ÷ 8 = (160 + 32) ÷ 8 = 20 + 4",
          "24 groepjes"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk 192 ÷ 8 = 22. Maar 22 × 8 = 176, niet 192. Controleer: 24 × 8 = 192.",
          "1": "Goed! 192 ÷ 8 = 24 groepjes. Je hebt de leerlingen correct verdeeld over de groepjes.",
          "2": "Je dacht waarschijnlijk 192 ÷ 8 = 26. Maar 26 × 8 = 208, niet 192. Controleer: 24 × 8 = 192.",
          "3": "Je dacht waarschijnlijk 192 ÷ 8 = 21. Maar 21 × 8 = 168, niet 192. Controleer: 24 × 8 = 192."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.calculation-error", "label": "Deelfout: 192÷8≈22", "optionIndex": 0 },
          { "id": "rek.calculation-error", "label": "Deelfout: 192÷8≈26", "optionIndex": 2 },
          { "id": "rek.calculation-error", "label": "Deelfout: 192÷8≈21", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-CONTEXT-KEER-DEEL-008",
      "familyId": "REK-CONTEXT-KEER-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_vermenigvuldigen_delen",
      "questionType": "multiple_choice",
      "question": "Voor het klassenfeest koopt de juf 16 zakken snoep. In elke zak zitten 35 snoepjes. Hoeveel snoepjes heeft ze in totaal?",
      "options": ["480", "560", "520", "600"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Aantal zakken × per zak = totaal",
            "content": "16 × 35: splits 35 in 30 + 5. 16 × 30 = 480, 16 × 5 = 80, samen 560. Of: 16 × 35 = 8 × 70 = 560 (verdubbel-halveer).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_keer_deel_klassenfeest",
      "variantIndex": 8,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "16 × 35 = 560 snoepjes. Signaalwoord: 'in elke zak' wijst op vermenigvuldigen. Handig: 16 × 35 = 16 × 30 + 16 × 5 = 480 + 80 = 560. Of via verdubbel-halveer: 16 × 35 = 8 × 70 = 560. Tegenproef: 560 ÷ 16 = 35 ✓",
        "solutionSteps": [
          "Herken: aantal zakken × per zak = vermenigvuldigen",
          "16 × 35 = 16 × 30 + 16 × 5",
          "480 + 80 = 560 snoepjes"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk 16 × 30 = 480 en vergat de eenheden. 16 × 5 = 80 komt er nog bij: 480 + 80 = 560.",
          "1": "Goed! 16 × 35 = 560 snoepjes in totaal.",
          "2": "Je dacht waarschijnlijk 16 × 32 = 512 of vergelijkbaar. Controleer: 16 × 35 = 16 × 30 + 16 × 5 = 480 + 80 = 560.",
          "3": "Je dacht waarschijnlijk 20 × 30 = 600. Maar het zijn 16 zakken van 35, niet 20 × 30. 16 × 35 = 560."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.partial-calculation", "label": "Stopt bij eerste deelproduct (16×30=480)", "optionIndex": 0 },
          { "id": "rek.calculation-error", "label": "Vermenigvuldigfout: 16×35≈520", "optionIndex": 2 },
          { "id": "rek.rounding-wrong-direction", "label": "Rondt af naar 20×30=600", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-CONTEXT-KEER-DEEL-009",
      "familyId": "REK-CONTEXT-KEER-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_vermenigvuldigen_delen",
      "questionType": "multiple_choice",
      "question": "Er zijn 250 leerlingen die op schoolkamp gaan. Ze gaan in busjes waar precies 8 leerlingen in passen. Hoeveel busjes zijn er minimaal nodig?",
      "options": ["32", "31", "30", "33"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Delen met rest in context",
            "content": "250 ÷ 8 = 31 rest 2. Dat betekent 31 volle busjes en nog 2 leerlingen over. Die 2 leerlingen moeten ook mee, dus je hebt een extra busje nodig: 31 + 1 = 32 busjes.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_keer_deel_rest_afronden_boven",
      "variantIndex": 9,
      "citoDifficulty": 0.60,
      "citoDiscrimination": 0.85,
      "feedback": {
        "explanationText": "250 ÷ 8 = 31 rest 2. Er zijn 31 volle busjes, maar er blijven 2 leerlingen over. Die moeten ook mee, dus je hebt 32 busjes nodig. Bij verdelen met rest in een context kijk je altijd: moet de rest óók een eigen plek hebben? Zo ja, dan rond je af naar boven.",
        "solutionSteps": [
          "Herken: verdelen in groepjes = delen",
          "250 ÷ 8 = 31 rest 2",
          "31 volle busjes",
          "2 leerlingen over → 1 extra busje",
          "31 + 1 = 32 busjes"
        ],
        "distractorExplanations": {
          "0": "Goed! 250 ÷ 8 = 31 rest 2. Voor de overgebleven 2 leerlingen heb je nog een busje nodig, dus 32.",
          "1": "Je hebt de rest genegeerd. Met 31 busjes kunnen er maar 31 × 8 = 248 leerlingen mee. Er blijven 2 leerlingen achter — die moeten ook mee!",
          "2": "Je hebt waarschijnlijk een rekenfout gemaakt. Controle: 30 × 8 = 240, dus 30 busjes is te weinig. 250 ÷ 8 = 31 rest 2.",
          "3": "Je hebt te veel busjes geteld. 32 busjes is genoeg voor 32 × 8 = 256 leerlingen; één extra is dus niet nodig."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "rek.division-remainder-ignored", "label": "Negeert de rest en rondt naar beneden af", "optionIndex": 1 },
          { "id": "rek.calculation-error", "label": "Rekenfout bij 250 ÷ 8", "optionIndex": 2 },
          { "id": "rek.calculation-error", "label": "Telt één busje te veel", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-CONTEXT-KEER-DEEL-010",
      "familyId": "REK-CONTEXT-KEER-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_vermenigvuldigen_delen",
      "questionType": "bar_model_part",
      "question": "Een sportclub verdeelt 240 leden gelijk over 6 teams. Vul de balk in: hoeveel leden zitten er in elk team?",
      "options": [],
      "correctAnswer": "40",
      "data": {
        "barModelPart": {
          "total": 240,
          "totalLabel": "240 leden",
          "segments": 6,
          "unknownSegmentIndex": 0,
          "showUnknownMarker": true,
          "highlighted": [0]
        },
        "acceptedAnswers": ["40"],
        "unit": ""
      },
      "stimulusAids": [
        {
          "type": "barModel",
          "data": {
            "total": 240,
            "totalLabel": "240 leden",
            "segments": 6,
            "showUnknownMarker": true,
            "highlighted": [0],
            "label": "Verdeel gelijk over 6 teams"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gelijke verdeling = delen",
            "content": "240 leden over 6 teams = 240 ÷ 6 = 40 leden per team. Tegenproef: 6 × 40 = 240 ✓.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_keer_deel_barmodel_verdelen",
      "variantIndex": 10,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "240 ÷ 6 = 40 leden per team. De balk laat zien hoe 240 in 6 gelijke delen wordt opgedeeld. Tegenproef: 6 × 40 = 240 ✓.",
        "solutionSteps": [
          "Herken: gelijke verdeling = delen",
          "240 ÷ 6 = 40",
          "Tegenproef: 6 × 40 = 240 ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "REK-CONTEXT-KEER-DEEL-011",
      "familyId": "REK-CONTEXT-KEER-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_vermenigvuldigen_delen",
      "questionType": "true_false_series",
      "question": "Hoort de bewerking bij het verhaaltje? Beoordeel per stelling of de berekening klopt.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          {
            "text": "Een klas van 24 leerlingen wordt verdeeld in groepjes van 4. Bewerking: 24 ÷ 4 = 6 groepjes.",
            "isTrue": true
          },
          {
            "text": "Een doos bevat 12 pakjes van 8 koekjes. Aantal koekjes totaal: 12 ÷ 8 = 1,5 koekjes.",
            "isTrue": false
          },
          {
            "text": "180 ballonnen worden verdeeld over 9 tafels. Per tafel: 180 × 9 = 1.620 ballonnen.",
            "isTrue": false
          },
          {
            "text": "Een fietsenwinkel verkoopt 7 fietsen per dag. In 14 dagen: 7 × 14 = 98 fietsen.",
            "isTrue": true
          }
        ]
      },
      "context": "Bewerking bij verhaaltje",
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verdelen vs. totaal berekenen",
            "content": "'Verdelen in groepjes/over' = delen (÷). 'Per X' of 'in elke X' bij totaal vragen = vermenigvuldigen (×). Lees goed: wat is gevraagd?",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_keer_deel_judge_bewerking",
      "variantIndex": 11,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "Let op signaalwoorden: 'verdelen over/in groepjes' = delen, 'per dag/per stuk' bij totaal = vermenigvuldigen. Stelling 2 en 3 hebben de verkeerde bewerking. Stelling 2: 12 × 8 = 96 koekjes (niet ÷). Stelling 3: 180 ÷ 9 = 20 ballonnen per tafel (niet ×).",
        "solutionSteps": [
          "Stelling 1: verdelen in groepjes → ÷ → 24 ÷ 4 = 6 ✓",
          "Stelling 2: totaal aantal → × → 12 × 8 = 96 (niet ÷) ✗",
          "Stelling 3: per tafel → ÷ → 180 ÷ 9 = 20 (niet ×) ✗",
          "Stelling 4: totaal in 14 dagen → × → 7 × 14 = 98 ✓"
        ]
      },
      "pedagogy": {
        "dok": 3
      }
    },
    {
      "id": "REK-CONTEXT-KEER-DEEL-012",
      "familyId": "REK-CONTEXT-KEER-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_vermenigvuldigen_delen",
      "questionType": "fill_in",
      "question": "Een fabriek verpakt 504 chocoladerepen in dozen van 12. Hoeveel dozen zijn er nodig?",
      "options": [],
      "correctAnswer": "42",
      "data": {
        "acceptedAnswers": ["42", "42 dozen"]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verpakken in dozen = delen",
            "content": "504 repen in dozen van 12 = 504 ÷ 12. Handig: 504 ÷ 2 = 252, dan 252 ÷ 6 = 42. Tegenproef: 42 × 12 = 504 ✓.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_keer_deel_fillin_dozen",
      "variantIndex": 12,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "504 ÷ 12 = 42 dozen. Handig: 12 = 2 × 6, dus 504 ÷ 2 = 252, dan 252 ÷ 6 = 42. Tegenproef: 42 × 12 = 504 ✓.",
        "solutionSteps": [
          "Herken: verpakken in dozen = delen",
          "504 ÷ 12 = 504 ÷ 2 ÷ 6",
          "252 ÷ 6 = 42 dozen",
          "Tegenproef: 42 × 12 = 504 ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    }
  ]
}